/* eslint-disable */
import { api } from '@/services/api'
import { resetState } from '@/store/helpers'


const initState = () => ({
  organization: null,
  members: [],
  package: null,
  billingAccount: null,

  // for options during user management
  memberSlotsHasMax: false,
  memberSlotsTotal: null,
  memberSlotsRemaining: null,
});

const mutations = {
  reset(state) {
    resetState(state, initState())
  },
  setOrganization(state, org) {
    state.organization = org

    // process the org billing account, member/package config
    if (!!org.billingAccount) {
      state.billingAccount = org.billingAccount

      // make sure we have a package for the org set
      if (!!org.billingAccount.autoreloadPackage) {
        state.package = org.billingAccount.autoreloadPackage
      } else if (!!org.billingAccount.subscriptionPackage) {
        state.package = org.billingAccount.subscriptionPackage
      } else {
        state.package = null
      }

      // check for accountConfig for member management
      if (!!org.billingAccount?.featureConfig?.orgMemberManagement?.members?.maxAllowed) {
        if (org.billingAccount?.featureConfig?.orgMemberManagement?.members?.maxAllowed > 1) {
          state.memberSlotsHasMax = true
          state.memberSlotsTotal = org.billingAccount?.featureConfig?.orgMemberManagement?.members?.maxAllowed
          state.memberSlotsRemaining = state.memberSlotsTotal - state.members.length
        } else {
          state.memberSlotsHasMax = false
          state.memberSlotsTotal = null
          state.memberSlotsRemaining = null
        }
      } else {
        state.memberSlotsHasMax = false
        state.memberSlotsTotal = null
        state.memberSlotsRemaining = null
      }
    }
  },
  setMembers(state, members) {
    state.members = members.filter(member =>  !!member.flags ? !member.flags.includes("org:member:removed") : member)

    if (state.memberSlotsHasMax) {
      state.memberSlotsRemaining = state.memberSlotsTotal - state.members.length
    }
  }
}

const getters = {
  baseURL (state) {
    return !!state.organization ? `/v1/organizations/${state.organization.id}` : ''
  },
  getMembers (state) {
    return state.members;
  },
  orgName(state) {
    return state?.organization ? state.organization.name : "";
  },
}

const actions = {
  initializeOrganizationByID({commit}, payload) {
    return new Promise((resolve, reject) => {
      api.get(`/v1/organizations/${payload.id}`).then((res) => {
        commit('setOrganization', res.data)
        resolve(res.data)
      }).catch(reject)
    })
  },

  refresh({commit, getters}) {
    return new Promise((resolve, reject) => {
      api.get(getters.baseURL).then((res) => {
        commit('setOrganization', res.data)
        resolve(res.data)
      }).catch(reject)
    })
  },

  // load all members
  loadMembers({commit, getters}) {
    return new Promise((resolve, reject) => {
      api.get(getters.baseURL+'/memberships').then((res) => {
        commit('setMembers', res.data?.results)
        resolve(res.data?.results)
      }).catch(reject)
    })
  },
}

export default {
  namespaced: true,
  state: initState,
  mutations,
  actions,
  getters,
}
